import React from 'react';
import { css } from '@linaria/core';
import { brand, theme } from '@terveystalo/design-system-theme';
import { classnames } from '../../utils';
const lineStyles = css `
  display: block;
  height: ${theme.spacing['0_5']};
  border-radius: ${brand.skeleton.border.radius};
  background-color: ${brand.skeleton.color.default.background};
`;
const animationStyles = css `
  background-image: linear-gradient(
    to right,
    ${brand.skeleton.color.default.content.neutral} 30%,
    ${brand.skeleton.color.default.content.accent},
    ${brand.skeleton.color.default.content.neutral} 60%
  );
  background-position: 0 100%;
  background-size: 200% 100%;
  animation: shine 2s ease-in-out infinite;

  @keyframes shine {
    from {
      background-position: 100% 0;
    }
    to {
      background-position: -100% 0;
    }
  }
`;
/**
 * Renders an animated line for constructing skeleton views for loading states
 */
export function SkeletonLine(props) {
    const { as: Component = 'div', width, animate = true, className, style, ...rest } = props;
    return (React.createElement(Component, { "aria-hidden": "true", style: { ...style, width }, className: classnames(lineStyles, animate && animationStyles, className), ...rest }));
}


import "../../../css/atoms/SkeletonLine/SkeletonLine.css";
